// extracted by mini-css-extract-plugin
var _1 = "erFye";
var _2 = "VZAyT";
var _3 = "L1DOh";
export { _1 as "base", _2 as "container", _3 as "content" }
